const loadContacts = ({ commit }, payload) => {
    commit('LOAD_CONTACTS', payload);
};

export default {
    loadContacts,
};
